module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-builder__item-modal modal fade",
    attrs: {
      "id": "menuItemModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemTitle",
      "type": "text",
      "data-validation": "true"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.url),
      expression: "entity.url"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemUrl",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entity.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "url", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.tooltip),
      expression: "entity.tooltip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemTooltip",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entity.tooltip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "tooltip", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.target),
      expression: "entity.target"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemTarget"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "target", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "_self"
    }
  }, [_vm._v("In current tab")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "_blank"
    }
  }, [_vm._v("In new tab")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.route),
      expression: "entity.route"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemContentType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "route", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.entityTypesList), function(value) {
    return _c('option', {
      key: value.name,
      domProps: {
        "value": value.value
      }
    }, [_vm._v("\n                  " + _vm._s(value.name) + "\n                ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemPathAlias",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-1 d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.hidden),
      expression: "entity.hidden"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemPathAlias",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.hidden) ? _vm._i(_vm.entity.hidden, null) > -1 : (_vm.entity.hidden)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.hidden,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "hidden", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "hidden", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "hidden", $$c)
        }
      }
    }
  })])])]), _vm._v(" "), (_vm.entity.route) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.routeName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('vue-select', {
    attrs: {
      "label": "title",
      "filterable": false,
      "options": _vm.selectOptions
    },
    on: {
      "search": _vm.vueSelectOnSearch
    },
    model: {
      value: (_vm.entity.parameters),
      callback: function($$v) {
        _vm.$set(_vm.entity, "parameters", $$v)
      },
      expression: "entity.parameters"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.entity.image ? _vm.entity.image.public_url : '',
      "removable": true
    },
    on: {
      "changeFile": _vm.imageChange,
      "returnedOldFile": _vm.imageReturnedOld,
      "existingFileRemoved": _vm.imageRemove
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-modal-error",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary save-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v("\n          Save changes\n          "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Menu item")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemTitle"
    }
  }, [_vm._v("Title*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemUrl"
    }
  }, [_vm._v("Url")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemTooltip"
    }
  }, [_vm._v("Tooltip")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemTooltip"
    }
  }, [_vm._v("Open page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemContentType"
    }
  }, [_vm._v("Entity Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemPathAlias"
    }
  }, [_vm._v("Page Path Alias")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemPathAlias"
    }
  }, [_vm._v("Hidden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', [_vm._v("Image")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f3b4892","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/modals/MenuItem.vue
// module id = 819
// module chunks = 0